import React from 'react';
import SVG from 'react-inlinesvg';

import infoSvg from 'assets/alerts/info.svg';
import warningSvg from 'assets/alerts/warning.svg';
import successSvg from 'assets/alerts/success.svg';
import errorSvg from 'assets/alerts/error.svg';
import styled from 'styled-components';

const HintsStyled = styled.div<{
  alertVariant: string;
  isColumn: boolean;
}>`
  border-radius: 6px;
  padding: 5px;
  margin-left: ${({ isColumn }) => !isColumn && '9px'};
  margin-right: ${({ isColumn }) => !isColumn && '9px'};
  margin-top: ${({ isColumn }) => isColumn && '5px'};

  background-color: ${({ alertVariant, theme }) =>
    alertVariant === 'info' && theme.colors.aliceBlue};
  color: ${({ alertVariant, theme }) => alertVariant === 'info' && theme.colors.malibu};

  background-color: ${({ alertVariant, theme }) =>
    alertVariant === 'warning' && theme.colors.earlyDawn};
  color: ${({ alertVariant, theme }) => alertVariant === 'warning' && theme.colors.orange};

  background-color: ${({ alertVariant, theme }) =>
    alertVariant === 'success' && theme.colors.oysterBay};
  color: ${({ alertVariant, theme }) => alertVariant === 'success' && theme.colors.lightSeaGreen};

  background-color: ${({ alertVariant, theme }) =>
    alertVariant === 'error' && theme.colors.palePink};
  color: ${({ alertVariant, theme }) => alertVariant === 'error' && theme.colors.radicalRed};

  svg {
    margin-right: 3px;
  }
`;

export type HintsProps = {
  alertVariant?: 'info' | 'warning' | 'success' | 'error';
  message?: string;
  icon?: boolean;
  isColumn?: boolean;
};

const Hints = ({ alertVariant = 'info', message, icon, isColumn = false }: HintsProps) => {
  const displayIcon = () => {
    switch (alertVariant) {
      case 'info':
        return <SVG src={infoSvg} />;
      case 'warning':
        return <SVG src={warningSvg} />;
      case 'success':
        return <SVG src={successSvg} />;
      case 'error':
        return <SVG src={errorSvg} />;
      default:
        return <div>no icon</div>;
    }
  };

  return message ? (
    <HintsStyled alertVariant={alertVariant} isColumn={isColumn}>
      {icon && displayIcon()}
      {message}
    </HintsStyled>
  ) : null;
};

export default Hints;
